import { makeStyles, tokens } from "@fluentui/react-components";
import { iconFilledClassName } from "@fluentui/react-icons";

export const useStyles = makeStyles({
  spinner: { whiteSpace: "nowrap" },
  overflowMenuButton: {
    "--colorSubtleBackgroundSelected": tokens.colorBrandBackground2,
    "--colorSubtleBackgroundHover": tokens.colorBrandBackground2,
    "--colorSubtleBackgroundPressed": tokens.colorBrandBackground2,
    ":focus-visible": {
      backgroundColor: tokens.colorBrandBackground2,
    },
  },
  overflowMenuIcon: {
    [`&.${iconFilledClassName}`]: {
      color: tokens.colorBrandForeground1,
    },
  },
});
